import { Button } from '@mui/material';
import React, { useEffect } from 'react';
import { Outlet, Link } from "react-router-dom";
import { useNavigate } from 'react-router-dom';

const Menu = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Make sidebar fixed and scroll independently per AdminLTE
    document.body.classList.add('layout-fixed');
    return () => {
      document.body.classList.remove('layout-fixed');
    };
  }, []);

  const toggleSidebar = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    // AdminLTE toggles `sidebar-collapse` to close, remove to open
    document.body.classList.toggle('sidebar-collapse');
  };

  const toggleSubmenu = (e) => {
    e.preventDefault();
    const parent = e.currentTarget.parentElement;
    const icon = e.currentTarget.querySelector('.right');

    // Close all other open menus
    const allMenuItems = document.querySelectorAll('.nav-item.has-treeview');
    allMenuItems.forEach(item => {
      if (item !== parent) {
        item.classList.remove('menu-open');

        const rightIcon = item.querySelector('.right');
        if (rightIcon) {
          rightIcon.classList.remove('fa-angle-up');
          rightIcon.classList.add('fa-angle-down');
        }
      }
    });

    // Toggle current menu
    const isOpen = parent.classList.toggle('menu-open');

    // Set correct arrow
    if (isOpen) {
      icon.classList.remove('fa-angle-down');
      icon.classList.add('fa-angle-up');
    } else {
      icon.classList.remove('fa-angle-up');
      icon.classList.add('fa-angle-down');
    }
  };

  const handleLogout = () => {
    // Clear cookies
    document.cookie = "token=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Strict";
    document.cookie = "userid=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Strict";

    // Optionally, clear other localStorage data (if necessary)
    localStorage.removeItem("isAuthenticated");
    localStorage.removeItem("welcomeMessageShown");

    // Redirect to login page
    navigate("/login");
  };

  return (
    <>
      {/* <Header/> */}
      <div className="wrapper">
        <nav className="main-header navbar navbar-expand navbar-white navbar-light">
          <ul className="navbar-nav">
            <li className="nav-item">
              <a className="nav-link" data-widget="pushmenu" href="#" role="button" onClick={toggleSidebar}><i className="fas fa-bars" /></a>
            </li>
          </ul>

          <ul className="navbar-nav ml-auto">
            <li className="nav-item">
              <Button onClick={handleLogout} style={{
                padding: '5px 10px',
                backgroundColor: '#007bff',
                color: '#fff',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                transition: 'background-color 0.3s ease',
                marginLeft: 'auto'
              }}>
                Logout
              </Button>
            </li>
          </ul>
        </nav>
        <aside className="main-sidebar sidebar-dark-primary elevation-4" style={{ height: '100vh' }}>
          <div className="sidebar">
            <div className="user-panel mt-3 pb-3 mb-3 d-flex">
              <div className="info">
                <a href="#" className="d-block">Bonrix</a>
              </div>
            </div>
            <nav className="mt-2">
              <ul className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">

                {/* Dashboard */}
                <li className="nav-item">
                  <a href="/" className="nav-link">
                    <i className="nav-icon fas fa-tachometer-alt" />
                    <p>Dashboard</p>
                  </a>
                </li>

                {localStorage.getItem('hasthirdpartyhtml') === 'true' && (
                  <>
                    {/* <li className="nav-item">
                      <a href="/select-option" className="nav-link">
                        <i className="nav-icon fas fa-th-large" />
                        <p>Portal Selection</p>
                      </a>
                    </li> */}
                    {/* <li className="nav-item">
                      <a href="/third-party-report" className="nav-link">
                        <i className="nav-icon fas fa-chart-line" />
                        <p>Third Party Report</p>
                      </a>
                    </li> */}
                    {/* <li className="nav-item">
                      <a href="/retail-pulse-report" className="nav-link">
                        <i className="nav-icon fas fa-chart-pie" />
                        <p>RetailPulse Report</p>
                      </a>
                    </li> */}
                  </>
                )}

                
                   <li className="nav-item has-treeview">
                  <a href="#" className="nav-link" onClick={toggleSubmenu}>
                    <i className="nav-icon fas fa-book-open" />
                    <p>
                      Catalogue Dashboard
                      <i className="right fas fa-angle-down" />
                    </p>
                  </a>
                  <ul className="nav nav-treeview">
                         <li className="nav-item">
                      <a href="/catalog-dashboard" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Catalogue Dashboard</p>
                      </a>
                    </li>
                      <li className="nav-item">
                      <a href="/pos-dashboard" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>POS Dashboard</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="/catalog-statistics" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Catalogue Statistics</p>
                      </a>
                    </li>
                  </ul>
                </li>

                {/* All List Menu with Submenu */}
                <li className="nav-item has-treeview">
                  <a href="#" className="nav-link" onClick={toggleSubmenu}>
                    <i className="nav-icon fas fa-list" />
                    <p>
                      Device Management
                      <i className="right fas fa-angle-down" style={{ transform: 'rotate(-0deg)' }} />
                    </p>
                  </a>
                  <ul className="nav nav-treeview">
                    <li className="nav-item">
                      <a href="/merchantList" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Merchant List</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="/group" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Sub Group</p>
                      </a>
                    </li>
                  </ul>
                </li>


                <li className="nav-item has-treeview">
                  <a href="#" className="nav-link" onClick={toggleSubmenu}>
                    <i className="nav-icon fas fa-list" />
                    <p>
                      Content Management
                      <i className="right fas fa-angle-down" style={{ transform: 'rotate(-0deg)' }} />
                    </p>
                  </a>
                  <ul className="nav nav-treeview">

                    <li className="nav-item">
                      <a href="/compaign" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Campaign</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="/audio" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Audio</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="/audioPackage" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Audio Package</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="/catelog" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Catalogue</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="/schedulelist" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Schedule</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="/dqr-image-list" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Dqr Images</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="/firmware" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Firmware</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="/htmldoclist" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Html Doc</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="/htmldocziplist" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Html Doc Zip</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="/mqttSetting" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Json Setting</p>
                      </a>
                    </li>
                    {/* <li className="nav-item">
                      <a href="/serialnoMqttSetting" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Serialno Mqtt Setting</p>
                      </a>
                    </li> */}
                    <li className="nav-item">
                      <a href="/AWSIOTCoreList" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>AWSIOT Core List</p>
                      </a>
                    </li>
                  </ul>
                </li>

                {/* Send Menu with Submenu */}
                <li className="nav-item has-treeview">
                  <a href="#" className="nav-link" onClick={toggleSubmenu}>
                    <i className="nav-icon fas fa-paper-plane" />
                    <p>
                      Send
                      <i className="right fas fa-angle-down" style={{ transform: 'rotate(-0deg)' }} />
                    </p>
                  </a>
                  <ul className="nav nav-treeview">
                    <li className="nav-item">
                      <a href="/sendcompaign" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Send Campaign</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="/sendaudio" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Send Audio</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="/sendaudioPackage" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Send Audio Package</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="/send-catelog" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Send Catalogue</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="/sendSchedule" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Send Schedule</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="/send-Dqr-image" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Send DQR Images</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="/sendhtmldoc" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Send Html Doc</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="/sendhtmldoczip" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Send Html Doc Zip</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="/send-firmware" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Send Firmware</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="/sendMQTTSetting" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Send Json Setting</p>
                      </a>
                    </li>
                    {/* <li className="nav-item">
                      <a href="/sendSerialnoMqttSetting" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Send Serialno Mqtt Setting</p>
                      </a>
                    </li> */}

                  </ul>
                </li>


                <li className="nav-item has-treeview">
                  <a href="#" className="nav-link" onClick={toggleSubmenu}>
                    <i className="nav-icon fas fa-paper-plane" />
                    <p>
                      System Setting
                      <i className="right fas fa-angle-down" style={{ transform: 'rotate(-0deg)' }} />
                    </p>
                  </a>
                  <ul className="nav nav-treeview">

                    <li className="nav-item">
                      <a href="/api-doc" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>API Doc</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="/Client-page" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Client List</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="/upload-file-list" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Upload File</p>
                      </a>
                    </li>

                    <li className="nav-item">
                      <a href="/default-template" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Auto Template</p>
                      </a>
                    </li>

                  </ul>

                </li>


                <li className="nav-item has-treeview">
                  <a href="#" className="nav-link" onClick={toggleSubmenu}>
                    <i className="nav-icon fas fa-paper-plane" />
                    <p>
                      History
                      <i className="right fas fa-angle-down" style={{ transform: 'rotate(-0deg)' }} />
                    </p>
                  </a>
                  <ul className="nav nav-treeview">
                    <li className="nav-item">
                      <a href="/history" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>History</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="/messageQueueList" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Message Queue</p>
                      </a>
                    </li>

                  </ul>

                </li>





                {/* Other Menu Items */}
                <li className="nav-item">
                  <a href="/api-key-operation-list" className="nav-link">
                    <i className="nav-icon fas fa-key" />
                    <p>API Key Operation List</p>
                  </a>
                </li>
                <li className="nav-item">
                  <a href="/send" className="nav-link">
                    <i className="nav-icon fas fa-flask" />
                    <p>Test WS</p>
                  </a>
                </li>
                <li className="nav-item">
                  <a href="/Login-for-client" className="nav-link">
                    <i className="nav-icon fas fa-sign-in-alt" />
                    <p>Login</p>
                  </a>
                </li>

              </ul>
            </nav>
          </div>
        </aside>
        <aside className="control-sidebar control-sidebar-dark">
        </aside>
      </div>
      <Outlet />
    </>
  );
};

export default Menu;